import { Link } from "react-router-dom";

const GlobalBanner = ({ title, subtitle, bgImage }) => {
  return (
    <div
      className="bg-cover bg-no-repeat bg-center pt-40 pb-20 px-10 relative"
      style={{
        backgroundImage: `linear-gradient(rgba(15, 23, 43, 0.9), rgba(15, 23, 43, 0.7)), url(${bgImage})`,
      }}
    >
      <div className="container mx-auto px-4 text-center relative z-10">
        {title && (
          <h1 className="font-display text-white text-4xl md:text-5xl lg:text-6xl font-bold mb-4">
            {title}
          </h1>
        )}
        <div className="space-x-3 text-gray-300 mb-6 text-lg max-w-xl font-semibold mx-auto cursor-pointer ">
          <Link to="/">
            <span className="text-primary mb-6 text-lg max-w-xl mx-auto">
              Home
            </span>
          </Link>
          <span>/</span>
          <span className="text-white mb-6 text-lg max-w-xl mx-auto">
            {/* <p className="text-gray-300 mb-6 text-lg max-w-xl mx-auto"> */}
            {subtitle}
            {/* </p> */}
          </span>
        </div>
        {/* {subtitle && (
          <p className="text-gray-300 mb-6 text-lg max-w-xl mx-auto">
            {subtitle}
          </p>
        )} */}
      </div>
    </div>
  );
};

export default GlobalBanner;
